import type { FormFieldConfig } from '../components/common/FormField';

export const sourceFieldConfig: {
  section: string;
  columns: number;
  column: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Source Details',
    columns: 1,
    column: 0,
    fields: [
      { field: 'source_name', label: 'Source Name', type: 'text' },
      { field: 'source_type', label: 'Source Type', type: 'text' },
    ],
  },
];


